module.exports = __webpack_public_path__ + "static/media/AYS_SEARCH.5170f6a9.png";